import { render } from "./Wallets.vue?vue&type=template&id=243eba72&ts=true"
import script from "./Wallets.vue?vue&type=script&lang=ts"
export * from "./Wallets.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__